import {
  Card,
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { stopLoading } from "../../../../actions/loadingAction";
import {
  errorSnackbar,
  successSnackbar,
} from "../../../../actions/snackbarActions";
import { Endpoint, Status } from "../../../../apis/apiConstants";
import AjaxHelper from "../../../../apis/apiRequest";
import { ResponsiveDialogActions } from "../../../../constants/appConstants";
import { setResponsiveDialog } from "../../../../reducers/responsiveDialogReducer";
import "./helpline.component.scss";

export default function HelplineComponent(props) {
  const [approvals, setApprovals] = useState([]);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (props.approvalType === "Help request") {
      getPendingRequests();
    }
  }, [props.approvalType]);

  const getPendingRequests = () => {
    AjaxHelper.getApi(navigate, Endpoint.GET_OWN_HELP_REQUESTS)
      .then((response) => {
        if (response.data.status === Status.API_SUCCESS) {
          setApprovals(response.data.data);
        } else {
          setApprovals([]);
          console.log(response.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const deleteRelation = (id) => {
    AjaxHelper.postApi(navigate, `${Endpoint.DELETE_HELPLINE}/${id}`)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          dispatch(successSnackbar("Request deleted successfully."));
          getPendingRequests();
        } else {
          dispatch(errorSnackbar("Error while deleting the request."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while deleting the request."));
      });
  };

  return (
    <Card className="innerCard mt-3" variant="outlined">
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow className={"background-color-head"}>
              <TableCell>
                <span className={"font-bold font-18"}>Subject</span>
              </TableCell>
              <TableCell>
                <span className={"font-bold font-18"}>Content</span>
              </TableCell>
              <TableCell align="center">
                <span className={"font-bold font-18"}>Actions</span>
              </TableCell>
            </TableRow>
          </TableHead>

          {approvals.map((approval) => (
            <TableRow key={approval.id}>
              <TableCell>
                <div className="appFont">{`${approval.subject}`}</div>
              </TableCell>
              <TableCell>{approval.shortDescription}</TableCell>
              <TableCell align="center">
                <IconButton
                  onClick={() => {
                    dispatch(
                      setResponsiveDialog(
                        true,
                        "Delete",
                        "Do you want to delete the request?",
                        "Delete",
                        "Cancel",
                        (action) => {
                          if (action === ResponsiveDialogActions.POSITIVE) {
                            deleteRelation(approval._id);
                          }
                        }
                      )
                    );
                  }}
                >
                  <Delete color={"error"} />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </TableContainer>
    </Card>
  );
}
